import React from "react"
import { Segment, Header, Image, Button } from "semantic-ui-react"
import {
  DropitState,
  getTranslationsByScope,
  getUserRole,
} from "../core/reducers"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { ITranslations } from "../models"
import { $activateMaintenance, $deactivateMaintenance } from "../core/requests"
import maintenanceImg from "../core/assets/maintenance.jpg"

interface IMaintenanceManagement {
  isOnMaintenance: boolean
  translations: ITranslations["global"]
}

const MaintenanceManagement = (props: IMaintenanceManagement) => {
  const refreshToHome = () => window.location.replace(window.location.origin)
  const activateM = () => $activateMaintenance().then(() => refreshToHome())
  const deactivateM = () => $deactivateMaintenance().then(() => refreshToHome())
  return (
    <Segment className="maintenance-page">
      <div className="maintenance-header">
        <Header>
          {(props.isOnMaintenance &&
            "Dropit est actuellement en maintenance !") ||
            "Dropit est en fonctionnement normal !"}
        </Header>
        <Header>
          {
            "Vous pouvez activer ou désactiver la maintenance à partir de cette page"
          }
        </Header>
      </div>
      <div className="maintenance-image">
        <Image src={maintenanceImg} />
      </div>
      <div className="maintenance-buttons">
        <Button onClick={activateM}>{"Activer la maintenance"}</Button>
        <Button onClick={deactivateM}>{"Désactiver la maintenance"}</Button>
      </div>
      <div className="maintenance-back">
        <Button onClick={refreshToHome}>{"Retour à Dropit"}</Button>
      </div>
    </Segment>
  )
}

const mapStateToProps = (state: DropitState) => ({
  role: getUserRole(state),
  translations: getTranslationsByScope(state, "global"),
})

//   const mapDispatchToProps = {
//     fetchSupplierParameters
//   }

export default withRouter<any & any>(
  connect(
    mapStateToProps,
    undefined
    //   mapDispatchToProps
  )(MaintenanceManagement)
)
